﻿// © Microsoft Corporation. All rights reserved.

// Front Door issues an activityID (which we refer to as a RID) per page view and we use this ID in tracking and ad calls,
// There are specific circumstances where we need a unique GUID for every event, for example when navigating between slideshow images or refreshing ads withoug a page refresh
//   example usage:
//     mediator.pub("updatePageInstance");
//     var trackInfoRequestId = pageInstance.getRequestId() || trackInfo.sitePage.requestId;

import guidGen from "./guidGen";
import mediator from "./mediator";
import telemetryConstants from "./telemetryconstants";

var rid;
var pageInstanceEventName = "updatePageInstance";
var updatePageInstance = function () {
    rid = guidGen().replace(/-/g, "");

    mediator.pub(telemetryConstants.ResetIdx);

    // replace the impression guid for bing search box
    var form = document.body.querySelector("#srchfrm");
    if (form) {
        var refigInputs = form.querySelectorAll("input[name='refig']");
        var length = refigInputs.length;
        for (var i = 0; i < length; i++) {
            // @ts-ignore
            refigInputs[i].value = rid;
        }
    }
};

mediator.sub(pageInstanceEventName, updatePageInstance);

export default {
        getRequestId: function() { return rid; },
        setRequestId: function (newRequestId) {
            rid = newRequestId;

            // Reset eventIndex (telemetry related params) everytime requestId gets set
            mediator.pub(telemetryConstants.ResetIdx);
        },
        eventName: pageInstanceEventName,

        // exposing direct call to updatePageInstance to eliminate delay rid update
        // when executed via mediator.pub
        updatePageInstance: updatePageInstance
    };
